<template>
  <b-container class="organisation-list">
    <h1 class="organisation-title">My Organisations</h1>
    <template v-if="!organisationListLoading">
      <router-link
        :to="{ name: 'CreateOrganisation' }"
        tag="div"
        class="organisation-list-item-box">
        <span class="organisation-list-logo add-organisation" />
        <span class="organisation-list-title">
          Create New Organisation
        </span>
      </router-link>

      <template v-if="organisationList && organisationList.length">
        <router-link
          v-for="organisation in organisationList"
          :key="organisation.id"
          :to="{ name: 'Organisation', params: { organisationId: organisation.id, merchant_id: getFirstMerchantId(organisation) }}"
          tag="div"
          class="organisation-list-item-box organisation-list-item-box--organisation"
        >
          <span
            class="organisation-list-logo"
            :style="organisation.logo ? `background-image: url(${organisation.logo});` : ''">
            <span
              v-if="userHasUnreadMessages(organisation)"
              class="has-unread-wrapper">
              <span class="has-unread">{{ userHasUnreadMessages(organisation) }}</span>
            </span>
          </span>
          <div class="organisation-list-title">
            {{ organisation.name }}
          </div>
          <OrganisationDropdown :organisation="organisation"/>
        </router-link>
      </template>
    </template>
  </b-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import OrganisationDropdown from './OrganisationDropdown';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'OrganisationList',
  components: {
    OrganisationDropdown,
  },
  mixins: [
    ToasterMixin,
  ],
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm.turnOffEchoConnection();
    });
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      organisationList: 'organisation/organisationList',
      organisationListLoading: 'organisation/organisationListLoading',
      invitationsAccepted: 'user/invitationsAccepted',
      userEmail: 'user/email',
      apiError: 'user/apiError',
    }),
  },
  watch: {
    apiError(error) {
      if (error.status === 422) {
        this.errorMessage = error.data.errors.invite_token[0];
      } else if (error.data) {
        this.errorMessage = error.data.message;
      }

      this.$nextTick(() => {
        this.$refs.errorModal.show();
      });
    },
    invitationsAccepted() {
      this.checkInvitations();
    },
  },
  mounted() {
    this.fetchOrganisations();
    this.fetchMerchantRoles();
    if (this.$route.query.invited && this.$route.query.invited !== this.userEmail) {
      this.showToaster('Please logout to be able to activate this invitation.', null, null, 'error');
    }
    this.checkInvitations();
  },
  methods: {
    ...mapActions({
      fetchOrganisations: 'organisation/fetchOrganisations',
      // turnOffEchoConnection: 'pusher/turnOffEchoConnection',
      fetchMerchantRoles: 'user/fetchMerchantRoles',
    }),
    ...mapMutations({
      clearInvitations: 'user/CLEAR_INVITATIONS',
    }),
    checkInvitations() {
      if (this.invitationsAccepted && this.invitationsAccepted.length) {
        this.invitationsAccepted.forEach((item) => {
          item.businesses.forEach((business) => {
            this.showToaster(`You'we been added to ${business.name} on ${item.organisation.name}.`, this.SBIconList.INFO); // TODO not per biznis but per org
          });
        });

        this.clearInvitations();
      }
    },
    userHasUnreadMessages(organisation) {
      const isEmpty = this.$lodash.isEmpty;

      if (isEmpty(organisation.businesses)) {
        return false;
      }

      // sum all businesses
      let sum = 0;
      organisation.businesses.forEach((o) => { sum += (isEmpty(o.unread_conversations) ? 0 : o.unread_conversations.all_unread); });

      // returns boolean, number or string(if > 99)
      return sum ? (sum < 100 ? sum : '99+') : false;
    },
    getFirstMerchantId(organisation) {
      return this.$lodash.isEmpty(organisation.businesses) ? null : organisation.businesses[0].id;
    },
  },
};
</script>

<style lang="scss" src="@/assets/css/modules/_organisation-list.scss" scoped></style>
